// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.submit[data-v-58505894] {\n  width: 100%;\n  height: 40px !important;\n  color: #fff;\n}\n.message[data-v-58505894] {\n  width: 100%;\n}\n.login-body[data-v-58505894],\n.login-card[data-v-58505894],\n.v-application--wrap[data-v-58505894] {\n  border-radius: 50px;\n}\n.v-application .mb-6[data-v-58505894] {\n  margin-bottom: 0px !important;\n}\n", ""]);
// Exports
module.exports = exports;
